import Vue from "vue";
import globals from "./globals";
import i18n from "./i18n";
import VueI18n from "vue-i18n";
let numberFormats = globals.numberFormats;
const number = {
  install: function(Vue) {
    Vue.prototype.$number = function(
      number,
      format = "round",
      locale = "",
      option = { cleanCurrency: false, useCurrency: "" }
    ) {
      if (!locale) {
        locale = this.$store.getters["profileStore/getNumberFormatFormat"];
      }
      if (
        numberFormats[locale] &&
        !numberFormats[locale].hasOwnProperty(format)
      ) {
        format = "round";
      }
      if (
        numberFormats[locale] &&
        numberFormats[locale][format] &&
        option.useCurrency
      ) {
        numberFormats[locale][format].currency = option.useCurrency;
      }
      let localI18n = new VueI18n({
        locale: i18n.locale, // set locale
        fallbackLocale: i18n.fallbackLocale, // set fallback locale
        numberFormats: numberFormats
      });
      let n = localI18n.n(Number(number), format, locale);

      if (option.cleanCurrency) {
        n = n.replace(
          (option.useCurrency ||
            numberFormats[locale] ||
            numberFormats[i18n.fallbackLocale])[format].currency,
          ""
        );
      }
      return n;
    };
  }
};
Vue.use(number);
export default number;
